import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import AssertionFailedException from './AssertionFailedException';
var Assert = /*#__PURE__*/function () {
  function Assert() {
    _classCallCheck(this, Assert);
  }
  _createClass(Assert, null, [{
    key: "shouldNeverReachHere",
    value: function shouldNeverReachHere() {
      if (arguments.length === 0) {
        Assert.shouldNeverReachHere(null);
      } else if (arguments.length === 1) {
        var message = arguments[0];
        throw new AssertionFailedException('Should never reach here' + (message !== null ? ': ' + message : ''));
      }
    }
  }, {
    key: "isTrue",
    value: function isTrue() {
      if (arguments.length === 1) {
        var assertion = arguments[0];
        Assert.isTrue(assertion, null);
      } else if (arguments.length === 2) {
        var _assertion = arguments[0],
          message = arguments[1];
        if (!_assertion) if (message === null) throw new AssertionFailedException();else throw new AssertionFailedException(message);
      }
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 2) {
        var expectedValue = arguments[0],
          actualValue = arguments[1];
        Assert.equals(expectedValue, actualValue, null);
      } else if (arguments.length === 3) {
        var _expectedValue = arguments[0],
          _actualValue = arguments[1],
          message = arguments[2];
        if (!_actualValue.equals(_expectedValue)) throw new AssertionFailedException('Expected ' + _expectedValue + ' but encountered ' + _actualValue + (message !== null ? ': ' + message : ''));
      }
    }
  }]);
  return Assert;
}();
export { Assert as default };